fx.ns("models", class EmptyMedia extends fx.Media {

	constructor(data)
	{
        super({id:0});
        
        this.isBlob = false;
        this.loaded = true;

        this._emptyCache = {data : this.getUrl(), width:1000, height : 1000};

	}

    get image()
    {
        return this._emptyCache;
    }

    get isTemporary()
    {
        return true;
    }

    get storable(){
        return false;
    }

    isLoaded(effect)
    {
        return true;
    }

    hasEffect(effect)
    {
        return false;
    }

    getUrl()
    {
        return fx.assets.imagePlaceHolder.content;
    }

    fetch(callback, effect)
    {
        let image = this._getCache(effect)
        callback({url : image.data, width : image.width, height : image.height, media : this});
    }
	
	_getCache(effect)
    {
        return this._emptyCache;
    }
});